import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { PlameConcept } from '../entities/plameConcept';

@Injectable()
export class PlameConceptService extends BaseCrudService<PlameConcept> {

  public uri = '/api/plameConcept/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance PlameConceptService');
  }

  buildSentence(entity?: PlameConcept, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = entity.code ? 'code'
        + QueryOperator.Contain + entity.code
        + QueryOperator.Split : QueryOperator.Empty;
      query = query.concat(
        entity.name ? 'name'
          + QueryOperator.Contain + entity.name
          + QueryOperator.Split : QueryOperator.Empty
      );
      if (entity.plameType && entity.plameType.id) {
        query = query.concat(
          'plameType.id' + QueryOperator.Equal + entity.plameType.id + QueryOperator.Split
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  // getSequenceCode(): Observable<string> {
  //     const url = this.rutaServidor + this.uri + 'maxCode/';
  //     return this.httpClient.get<any>(url)
  //         .pipe(
  //             map(response => {
  //                 // debugger;
  //                 const code = response.maxCode ? response.maxCode : FormatUtils.padLeftZero(0, 2);
  //                 const sequence = (parseInt(code, 10)) + 1;
  //                 return FormatUtils.padLeftZero(sequence, 2);
  //             }),
  //             tap(response =>  {
  //                //console.log(response);
  //             })
  //         );
  // }
}



// WEBPACK FOOTER //
// ./src/app/core/services/plame-concept.service.ts